import React, { useEffect, useState } from "react";
import { Card, Container, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { AiFillEdit } from "react-icons/ai";
import { BsCheck, BsFileEarmarkPlus, BsTrash, BsX } from "react-icons/bs";
import { useModals } from "@mantine/modals";
import { Badge, Button, Input, Text } from "@mantine/core";
import { getGradeList } from "../../actions/Grade.action";
import {
  deleteTerminalSubject,
  updateTerminalSubjectSerial,
} from "../../actions/TerminalSubject.action";
import { getTermName } from "../../constants/termArray";

const TerminalSubjectList = ({
  list,
  getGradeList,
  deleteTerminalSubject,
  updateTerminalSubjectSerial,
}) => {
  const [rawList, setRawList] = useState(list === null ? [] : list);
  const [changedList, setChangedList] = useState(null);

  const modals = useModals();

  useEffect(() => {
    if (list === null) {
      getGradeList();
    }
    if (list !== null) {
      setRawList(list);
    }
  }, [list, getGradeList]);

  const handleChange = (id, serial, gradeId) => {
    setChangedList({ id, serial });
    setRawList((prev) => {
      let newList = [...list];
      newList = newList.map((g) => {
        if (g.id === gradeId) {
          g.terminalSubjects = g.terminalSubjects.map((s) => {
            if (s.id === id) {
              s.serial = serial;
            }
            return s;
          });
        }
        return g;
      });
      return newList;
    });
  };

  const saveChanged = async () => {
    await updateTerminalSubjectSerial(changedList.id, changedList.serial);
    setChangedList(null);
  };

  const deleteHandeler = (id) =>
    modals.openConfirmModal({
      title: "Delete this terminal subject",
      centered: true,
      children: (
        <Text size="md">
          Are you sure you want to delete this terminal subject? This action is
          destructive and you can not undo it.
        </Text>
      ),
      labels: {
        confirm: "Delete Terminal Subject",
        cancel: "No don't delete it",
      },
      confirmProps: { color: "red" },
      onCancel: () => {},
      onConfirm: () => confirmHandeler(id),
    });

  const confirmHandeler = async (id) => {
    await deleteTerminalSubject(id);
  };

  return (
    <Container className="pb-4">
      <div className="d-flex justify-content-end align-items-center pb-4">
        <Link to="/admin/terminal-subject/add">
          <Button
            leftIcon={<BsFileEarmarkPlus size={16} />}
            className="btn_primary"
          >
            Add Terminal Subject
          </Button>
        </Link>
      </div>

      {rawList === null ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : rawList.length === 0 ? (
        <Card className="text-center py-5">
          <Card.Body>
            <h5 className="text-muted">No terminal subjects found</h5>
            <p className="text-muted">
              Click "Add Terminal Subject" to create your first terminal
              subject.
            </p>
          </Card.Body>
        </Card>
      ) : (
        rawList.map((grade) => (
          <Card key={grade.id} className="mb-4 shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">{grade.name}</h5>
            </Card.Header>
            <Card.Body>
              {grade.terminalSubjects && grade.terminalSubjects.length > 0 ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Serial</th>
                      <th>Name</th>
                      <th>Mark</th>
                      <th>Terms</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grade.terminalSubjects
                      .sort((a, b) => a.serial - b.serial)
                      .map((subject) => (
                        <tr key={subject.id}>
                          <td>
                            {changedList && changedList.id === subject.id ? (
                              <div className="d-flex align-items-center gap-2">
                                <Input
                                  type="number"
                                  value={changedList.serial}
                                  onChange={(e) =>
                                    setChangedList({
                                      ...changedList,
                                      serial: parseInt(e.target.value),
                                    })
                                  }
                                  style={{ width: "80px" }}
                                />
                                <Button
                                  size="xs"
                                  color="green"
                                  onClick={saveChanged}
                                >
                                  <BsCheck size={12} />
                                </Button>
                                <Button
                                  size="xs"
                                  color="red"
                                  onClick={() => setChangedList(null)}
                                >
                                  <BsX size={12} />
                                </Button>
                              </div>
                            ) : (
                              <span
                                className="text-primary fw-bold"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleChange(
                                    subject.id,
                                    subject.serial,
                                    grade.id
                                  )
                                }
                              >
                                {subject.serial}
                              </span>
                            )}
                          </td>
                          <td>
                            <span className="fw-medium">{subject.name}</span>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Badge color="blue" variant="light" size="sm">
                                Oral: {subject.oralMark}
                              </Badge>
                              <Badge color="green" variant="light" size="sm">
                                Writing: {subject.writingMark}
                              </Badge>
                              <Badge color="orange" variant="light" size="sm">
                                Total: {subject.mark}
                              </Badge>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-wrap gap-1">
                              {subject.terms.split(",").map((termId) => (
                                <Badge
                                  key={termId}
                                  color="green"
                                  variant="light"
                                  size="sm"
                                >
                                  {getTermName(termId)}
                                </Badge>
                              ))}
                            </div>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Link
                                to={`/admin/terminal-subject/${subject.id}/edit`}
                                className="text-primary"
                              >
                                <AiFillEdit size={20} />
                              </Link>
                              <button
                                className="btn btn-link text-danger p-0"
                                onClick={() => deleteHandeler(subject.id)}
                              >
                                <BsTrash size={18} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-4">
                  <p className="text-muted mb-0">
                    No terminal subjects found for this grade.
                  </p>
                </div>
              )}
            </Card.Body>
          </Card>
        ))
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  list: state.grade.grade,
});

const mapDispatchToProps = {
  getGradeList,
  deleteTerminalSubject,
  updateTerminalSubjectSerial,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminalSubjectList);
